import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemUser from '../assets/images/user.jpg';
import { setError, setSuccess } from '../common/toast/toast';
import contentCardBody from '../common/template/contentCardBody';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import Cookies from 'react-cookies';

import { 
	getListaCustoFolha, getListaCustoFrota, getListaCustoVendas, getListaCustoInvestimentos, getListaCustoOutrasDespesas,
	getListaCustoAbastecida, getListaKmRodado, 
	salvarCustoFolha, excluirCustoFolha, getListaVenda, getListaReceitaFrete,
	getListaUnidade
} from './dashboardCustoActions';

const anos = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

class DashboardCusto extends Component {

	state = {
		pesquisar: '',
		anos: [new Date().getFullYear()],
		meses: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
		ids_unidades: [],
		modo: 'expandido',
		custoFrota: true,
		custoAbastecida: true,
		custoFolha: true,
		custoVendas: true,
		custoInvestimentos: true,
		custoOutros: true,
		totalKmRodado: true,
		mediaKmRodado: true,
		custoFrotaKmRodado: true,
		custoAbastecidaKmRodado: true,
		vendasValor: true,
		vendasQuantidade: true,
		custoLitroVenda: true,
		modalCustoFolha: null,
		receitaFrete: true
	}

	constructor(props) {
		super(props);
    }

    componentWillMount() {

		this.atualizar({ ids_unidades: this.state.ids_unidades });
		this.props.getListaUnidade();
    
		let idInterval = setInterval(() => {
			this.atualizar({ ids_unidades: this.state.ids_unidades });
		}, 30000);

		const cookieFiltro = Cookies.load('dashboardCustosFiltro');
		if (!cookieFiltro) {
			Cookies.save('dashboardCustosFiltro', JSON.stringify({
				anos: this.state.anos,
				meses: this.state.meses,
				ids_unidades: this.state.ids_unidades,
				modo: this.state.modo,
				custoFrota: this.state.custoFrota,
				custoAbastecida: this.state.custoAbastecida,
				custoFolha: this.state.custoFolha,
				custoVendas: this.state.custoVendas,
				custoInvestimentos: this.state.custoInvestimentos,
				custoOutros: this.state.custoOutros,
				totalKmRodado: this.state.totalKmRodado,
				mediaKmRodado: this.state.mediaKmRodado,
				custoFrotaKmRodado: this.state.custoFrotaKmRodado,
				custoAbastecidaKmRodado: this.state.custoAbastecidaKmRodado,
				vendasValor: this.state.vendasValor,
				vendasQuantidade: this.state.vendasQuantidade,
				custoLitroVenda: this.state.custoLitroVenda,
				receitaFrete: this.state.receitaFrete
			}), { path: '/' });

			this.setState({
				...this.state,
				idInteral: idInterval
			});
		} else {
			this.setState({
				...this.state,
				idInteral: idInterval,
				anos: cookieFiltro ? cookieFiltro.anos || this.state.anos : this.state.anos,
				meses: cookieFiltro ? cookieFiltro.meses || this.state.meses : this.state.meses,
				ids_unidades: cookieFiltro ? cookieFiltro.ids_unidades || this.state.ids_unidades : this.state.ids_unidades,
				modo: cookieFiltro ? cookieFiltro.modo || this.state.modo : this.state.modo,
				custoFrota: cookieFiltro ? cookieFiltro.custoFrota : true,
				custoAbastecida: cookieFiltro ? cookieFiltro.custoAbastecida : true,
				custoFolha: cookieFiltro ? cookieFiltro.custoFolha : true,
				custoVendas: cookieFiltro ? cookieFiltro.custoVendas : true,
				custoInvestimentos: cookieFiltro ? cookieFiltro.custoInvestimentos : true,
				custoOutros: cookieFiltro ? cookieFiltro.custoOutros : true,
				totalKmRodado: cookieFiltro ? cookieFiltro.totalKmRodado : true,
				mediaKmRodado: cookieFiltro ? cookieFiltro.mediaKmRodado : true,
				custoFrotaKmRodado: cookieFiltro ? cookieFiltro.custoFrotaKmRodado : true,
				custoAbastecidaKmRodado: cookieFiltro ? cookieFiltro.custoAbastecidaKmRodado : true,
				vendasValor: cookieFiltro ? cookieFiltro.vendasValor : true,
				vendasQuantidade: cookieFiltro ? cookieFiltro.vendasQuantidade : true,
				custoLitroVenda: cookieFiltro ? cookieFiltro.custoLitroVenda : true
			});
		}
	}

	atualizar(filtro) {
		this.props.getListaCustoFolha(filtro);
		this.props.getListaCustoFrota(filtro);
		this.props.getListaCustoVendas(filtro);
		this.props.getListaCustoInvestimentos(filtro);
		this.props.getListaCustoOutrasDespesas(filtro);
		this.props.getListaCustoAbastecida(filtro);
		this.props.getListaKmRodado(filtro);
		this.props.getListaVenda(filtro);
		this.props.getListaReceitaFrete(filtro);
	}

	componentWillUnmount() {
		
		clearInterval(this.state.idInteral);
		
	}

	validaCompetencia(competencia) {

		let valida = false;

		(this.state.anos || []).forEach(ano => {
			if ((this.state.meses || []).map(mes => parseInt(`${ano}${mes}`)).includes(parseInt(competencia))) {
				valida = true;
			}
		});

		return valida;
	}

	atualizarCookie(filtro) {
		Cookies.save('dashboardCustosFiltro', JSON.stringify({
			anos: filtro.anos,
			meses: filtro.meses,
			ids_unidades: filtro.ids_unidades,
			modo: filtro.modo,
			custoFrota: filtro.custoFrota,
			custoAbastecida: filtro.custoAbastecida,
			custoFolha: filtro.custoFolha,
			custoVendas: filtro.custoVendas,
			custoInvestimentos: filtro.custoInvestimentos,
			custoOutros: filtro.custoOutros,
			totalKmRodado: filtro.totalKmRodado,
			mediaKmRodado: filtro.mediaKmRodado,
			custoFrotaKmRodado: filtro.custoFrotaKmRodado,
			custoAbastecidaKmRodado: filtro.custoAbastecidaKmRodado,
			vendasValor: filtro.vendasValor,
			vendasQuantidade: filtro.vendasQuantidade,
			custoLitroVenda: filtro.custoLitroVenda,
			receitaFrete: filtro.receitaFrete
		}), { path: '/' });

		this.setState({
			...filtro
		});
	}

    render() {

		const listaCustoFrota = this.props.listaCustoFrota.filter(item => this.validaCompetencia(item.competencia));
		const listaCustoVendas = this.props.listaCustoVendas.filter(item => this.validaCompetencia(item.competencia));
		const listaCustoInvestimentos = this.props.listaCustoInvestimentos.filter(item => this.validaCompetencia(item.competencia));
		const listaCustoAbastecida = this.props.listaCustoAbastecida.filter(item => this.validaCompetencia(item.competencia));
		const listaCustoFolha = this.props.listaCustoFolha.filter(item => this.validaCompetencia(item.competencia));
		const listaCustoOutrasDespesas = this.props.listaCustoOutrasDespesas.filter(item => this.validaCompetencia(item.competencia));
		const listaKmRodado = this.props.listaKmRodado.filter(item => this.validaCompetencia(item.competencia));
		const listaVenda = this.props.listaVenda.filter(item => this.validaCompetencia(item.competencia));
		const listaReceitaFrete = this.props.listaReceitaFrete.filter(item => this.validaCompetencia(item.competencia));

		let valorTotalFrota = 0;
		let maiorValorFrota = 0;

		const anosSelecionados = this.state.anos || [];

		listaCustoFrota.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalFrota += parseFloat(item.valor);
			maiorValorFrota = parseFloat(item.valor) > maiorValorFrota ? parseFloat(item.valor) : maiorValorFrota;
		});

		let valorTotalCustoVendas = 0;
		let maiorValorCustoVendas = 0;
		listaCustoVendas.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalCustoVendas += parseFloat(item.valor);
			maiorValorCustoVendas = parseFloat(item.valor) > maiorValorCustoVendas ? parseFloat(item.valor) : maiorValorCustoVendas;
		});

		let valorTotalCustoInvestimentos = 0;
		let maiorValorCustoInvestimentos = 0;
		listaCustoInvestimentos.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalCustoInvestimentos += parseFloat(item.valor);
			maiorValorCustoInvestimentos = parseFloat(item.valor) > maiorValorCustoInvestimentos ? parseFloat(item.valor) : maiorValorCustoInvestimentos;
		});

		let valorTotalAbastecida = 0;
		let maiorValorAbastecida = 0;
		listaCustoAbastecida.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalAbastecida += parseFloat(item.valor);
			maiorValorAbastecida = parseFloat(item.valor) > maiorValorAbastecida ? parseFloat(item.valor) : maiorValorAbastecida;
		});
		
		let valorTotalFolha = 0;
		let maiorValorFolha = 0;
		listaCustoFolha.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalFolha += parseFloat(item.valor);
			maiorValorFolha = parseFloat(item.valor) > maiorValorFolha ? parseFloat(item.valor) : maiorValorFolha;
		});

		let valorTotalOutros = 0;
		let maiorValorOutros = 0;
		listaCustoOutrasDespesas.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalOutros += parseFloat(item.valor);
			maiorValorOutros = parseFloat(item.valor) > maiorValorOutros ? parseFloat(item.valor) : maiorValorOutros;
		});

		let valorTotalKmRodado = 0;
		let maiorKmRodado = 0;
		listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalKmRodado += parseFloat(item.km_rodado_total);
			maiorKmRodado = parseFloat(item.km_rodado_total) > maiorKmRodado ? parseFloat(item.km_rodado_total) : maiorKmRodado;
		});

		let valorTotalKmRodadoMedia = 0;
		let maiorKmRodadoMedia = 0;
		let quantidadeMesesKmRodadoMedia = 0;
		listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			//Se estamos no mês atual projeta a km pra não distorcer a média
			if (item.competencia == `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`) {
				
				const diasMes = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate();
				const diaAtual = new Date().getDate();

				valorTotalKmRodadoMedia += (parseFloat(item.km_rodado_media) * diasMes) / diaAtual;
			} else {
				valorTotalKmRodadoMedia += parseFloat(item.km_rodado_media);
			}

			quantidadeMesesKmRodadoMedia++;
			
			maiorKmRodadoMedia = parseFloat(item.km_rodado_media) > maiorKmRodadoMedia ? parseFloat(item.km_rodado_media) : maiorKmRodadoMedia;
		});

		valorTotalKmRodadoMedia = quantidadeMesesKmRodadoMedia ? valorTotalKmRodadoMedia / quantidadeMesesKmRodadoMedia : 0;

		let custoTotalCustoFrotaKmRodado = 0;
		let custoTotalFrotaKmRodado = 0;
		let maiorCustoFrotaKmRodado = 0;

		let custoTotalCustoAbastecidaKmRodado = 0;
		let custoTotalAbastecidaKmRodado = 0;
		let maiorCustoAbastecidaKmRodado = 0;
		listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {

			const custoFrota = listaCustoFrota.filter(itemCusto => itemCusto.competencia == item.competencia)[0];						
			const custoFrotaMes = parseFloat(custoFrota ? custoFrota.valor : 0);
			const custoFrotaKmRodado = parseFloat(item.km_rodado_total) > 0 ? custoFrotaMes / parseFloat(item.km_rodado_total) : 0;

			custoTotalCustoFrotaKmRodado += custoFrotaMes;
			custoTotalFrotaKmRodado += parseFloat(item.km_rodado_total);
			maiorCustoFrotaKmRodado = custoFrotaKmRodado > maiorCustoFrotaKmRodado ? custoFrotaKmRodado : maiorCustoFrotaKmRodado;

			const custoAbastecida = listaCustoAbastecida.filter(itemCusto => itemCusto.competencia == item.competencia)[0];
			const custoAbastecidaMes = parseFloat(custoAbastecida ? custoAbastecida.valor : 0);
			const custoAbastecidaKmRodado = parseFloat(item.km_rodado_total) > 0 ? custoAbastecidaMes / parseFloat(item.km_rodado_total) : 0;

			custoTotalCustoAbastecidaKmRodado += custoAbastecidaMes;
			custoTotalAbastecidaKmRodado += parseFloat(item.km_rodado_total);
			maiorCustoAbastecidaKmRodado = custoAbastecidaKmRodado > maiorCustoAbastecidaKmRodado ? custoAbastecidaKmRodado : maiorCustoAbastecidaKmRodado;
		});

		let valorTotalCustoFrotaKmRodado = custoTotalFrotaKmRodado > 0 ? custoTotalCustoFrotaKmRodado / custoTotalFrotaKmRodado : 0;
		let valorTotalCustoAbastecidaKmRodado = custoTotalAbastecidaKmRodado > 0 ? custoTotalCustoAbastecidaKmRodado / custoTotalAbastecidaKmRodado : 0;

		let valorTotalVenda = 0;
		let maiorValorVenda = 0;
		let quantidadeTotalVenda = 0;
		let maiorQuantidadeVenda = 0;
		listaVenda.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalVenda += parseFloat(item.valor);
			maiorValorVenda = parseFloat(item.valor) > maiorValorVenda ? parseFloat(item.valor) : maiorValorVenda;

			quantidadeTotalVenda += parseFloat(item.quantidade);
			maiorQuantidadeVenda = parseFloat(item.quantidade) > maiorQuantidadeVenda ? parseFloat(item.quantidade) : maiorQuantidadeVenda;
		});

		let listaCustoLitroVenda = [];
		let valorTotalCustoVenda = 0;
		let valorTotalValorVenda = 0;
		let maiorCustoLitroVenda = 0;
		listaVenda.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			const custoFrota = listaCustoFrota.filter(custo => custo.competencia == item.competencia)[0] || {};
			const custoVenda = listaCustoVendas.filter(custo => custo.competencia == item.competencia)[0] || {};
			const custoAbastecida = listaCustoAbastecida.filter(custo => custo.competencia == item.competencia)[0] || {};
			const custoFolha = listaCustoFolha.filter(custo => custo.competencia == item.competencia)[0] || {};
			const custoOutros = listaCustoOutrasDespesas.filter(custo => custo.competencia == item.competencia)[0] || {};
			const custoTotal = parseFloat(custoFrota.valor || 0) 
				+ parseFloat(custoVenda.valor || 0) 
				+ parseFloat(custoAbastecida.valor || 0)
				+ parseFloat(custoFolha.valor || 0)
				+ parseFloat(custoOutros.valor || 0);
			
			if (parseFloat(item.quantidade || 0) > 0 && custoTotal > 0) {
				const custoLitroVenda = custoTotal / parseFloat(item.quantidade || 0);

				listaCustoLitroVenda.push({
					competencia: item.competencia,
					valor: custoLitroVenda
				});

				maiorCustoLitroVenda = custoLitroVenda > maiorCustoLitroVenda ? custoLitroVenda : maiorCustoLitroVenda;
				valorTotalCustoVenda += custoTotal;
				valorTotalValorVenda += parseFloat(item.quantidade || 0);
			}
		});

		let custoMedioLitroVenda = valorTotalValorVenda > 0 ? valorTotalCustoVenda / valorTotalValorVenda : 0;

		let valorTotalReceitaFrete = 0;
		let maiorValorReceitaFrete = 0;
		listaReceitaFrete.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))).forEach(item => {
			valorTotalReceitaFrete += parseFloat(item.valor);
			maiorValorReceitaFrete = parseFloat(item.valor) > maiorValorReceitaFrete ? parseFloat(item.valor) : maiorValorReceitaFrete;
		});

		const cards = [
			{ key: 'custoFrota', label: 'Custo com Frota' },
			{ key: 'custoAbastecida', label: 'Custo com Abastecidas' },
			{ key: 'custoFolha', label: 'Custo com Pessoal e Terceiros' },
			{ key: 'custoVendas', label: 'Despesas com Vendas' },
			{ key: 'custoInvestimentos', label: 'Investimentos' },
			{ key: 'custoOutros', label: 'Outros Custos' },
			{ key: 'totalKmRodado', label: 'Total de Km Rodado' },
			{ key: 'mediaKmRodado', label: 'Média de Km Rodado' },
			{ key: 'custoFrotaKmRodado', label: 'Custo da Frota por Km Rodado' },
			{ key: 'custoAbastecidaKmRodado', label: 'Custo Abastecidas por Km Rodado' },
			{ key: 'vendasValor', label: 'Vendas Realizadas (R$)' },
			{ key: 'vendasQuantidade', label: 'Vendas Realizadas (Litros)' },
			{ key: 'custoLitroVenda', label: 'Custo por Litro Vendido (R$)' },
			{ key: 'receitaFrete', label: 'Receitas com Fretes (R$)' }
		];

        return (
			<>
				<Content>

					{this.modalCustoFolha()}

					<Row>
						<Select
							options={this.props.listaAnos}
							label='Anos'
							cols='12 4 2 2'
							placeholder='Selecione'
							multiple
							value={this.props.listaAnos.filter(item => this.state.anos.includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.atualizarCookie({ ...this.state, anos: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaMeses}
							label='Meses'
							cols='12 8 6 6'
							placeholder='Selecione'
							multiple
							value={this.props.listaMeses.filter(item => this.state.meses.includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.atualizarCookie({ ...this.state, meses: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaUnidade}
							label='Unidades'
							cols='12 12 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaUnidade.filter(item => this.state.ids_unidades.includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.atualizarCookie({ ...this.state, ids_unidades: (values || []).map(item => item.value) });
								this.atualizar({ ...this.state, ids_unidades: (values || []).map(item => item.value) });
							}} />
						
						<Select
							options={[{ id: 'expandido', valor: 'Não' }, { id: 'resumido', valor: 'Sim' }]}
							label='Resumido'
							cols='12 12 1 1'
							placeholder='Selecione'
							value={this.state.modo}
							onChange={value => {
								this.atualizarCookie({ ...this.state, modo: value });
							}} />
					</Row>

					<Row>
						<div
							style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: 12,
								justifyContent: 'center',
								marginBottom: 16
							}} >
							{cards.map(card => {
								const ativo = this.state[card.key];

								return (
									<div
										key={card.key}
										onClick={() =>
											this.atualizarCookie({
												...this.state,
												[card.key]: !ativo
											})
										}
										style={{
											display: 'flex',
											alignItems: 'center',
											cursor: 'pointer',
											width: 180,
											padding: 4,
											borderRadius: 12,
											transition: 'all 0.2s ease',
											border: ativo
												? '2px solid #111827'
												: '2px solid #E5E7EB',
											backgroundColor: ativo ? '#f5f5f5' : '#FFFFFF',
											color: ativo
												? '#111827'
												: '#6B7280',
											fontWeight: ativo ? 600 : 400,
											boxShadow: ativo
												? '0 4px 12px rgba(0,0,0,0.08)'
												: 'none',
											fontWeight: ativo ? '600' : 'lighter',
											textAlign: 'center',
											justifyContent: 'center',
											verticalAlign: 'center'
										}} >
										<div style={{ fontSize: 12 }}>
											{card.label}
										</div>
									</div>
								);
							})}
						</div>
					</Row>

					<Row>

						{this.cardComparativo(
							'custoFrota',
							'Custo com Frota',
							valorTotalFrota,
							listaCustoFrota.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorFrota,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'custoAbastecida',
							'Custo com Abastecidas',
							valorTotalAbastecida,
							listaCustoAbastecida.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorAbastecida,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'custoFolha',
							'Custo com Pessoal e Terceiros',
							valorTotalFolha,
							listaCustoFolha.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorFolha,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'custoVendas',
							'Despesas com Vendas',
							valorTotalCustoVendas,
							listaCustoVendas.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorCustoVendas,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'custoInvestimentos',
							'Investimentos',
							valorTotalCustoInvestimentos,
							listaCustoInvestimentos.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorCustoInvestimentos,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'custoOutros',
							'Outros Custos',
							valorTotalOutros,
							listaCustoOutrasDespesas.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorOutros,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'totalKmRodado',
							'Total de km Rodado',
							valorTotalKmRodado,
							listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'km_rodado_total',
							maiorKmRodado,
							null, //prefixo
							'km', //sufixo
							0, //casas
						)}

						{this.cardComparativo(
							'mediaKmRodado',
							'Média de km Rodado',
							valorTotalKmRodadoMedia,
							listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'km_rodado_media',
							maiorKmRodadoMedia,
							null, //prefixo
							'km', //sufixo
							0, //casas
						)}

						{this.cardComparativo(
							'custoFrotaKmRodado',
							'Custo da Frota por km Rodado',
							valorTotalCustoFrotaKmRodado,
							listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'km_rodado_media',
							maiorCustoFrotaKmRodado,
							'R$', //prefixo
							null, //sufixo
							2, //casas
							(item) => {
								const custoFrota = listaCustoFrota.filter(itemCusto => itemCusto.competencia == item.competencia)[0];

								const custoMes = parseFloat(custoFrota ? custoFrota.valor : 0);

								return parseFloat(item.km_rodado_total) > 0 ? custoMes / parseFloat(item.km_rodado_total) : 0;
							}
						)}

						{this.cardComparativo(
							'custoAbastecidaKmRodado',
							'Custo de Abastecidas por km Rodado',
							valorTotalCustoAbastecidaKmRodado,
							listaKmRodado.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'km_rodado_total',
							maiorCustoAbastecidaKmRodado,
							'R$', //prefixo
							null, //sufixo
							2, //casas
							(item) => {
								const custoAbastecida = listaCustoAbastecida.filter(itemCusto => itemCusto.competencia == item.competencia)[0];

								const custoMes = parseFloat(custoAbastecida ? custoAbastecida.valor : 0);

								return parseFloat(item.km_rodado_total) > 0 ? custoMes / parseFloat(item.km_rodado_total) : 0;
							}
						)}

						{this.cardComparativo(
							'vendasValor',
							'Vendas Realizadas (R$)',
							valorTotalVenda,
							listaVenda.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorVenda,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}

						{this.cardComparativo(
							'vendasQuantidade',
							'Vendas Realizadas (Litros)',
							quantidadeTotalVenda,
							listaVenda.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'quantidade',
							maiorQuantidadeVenda,
							null, //prefixo
							'L', //sufixo
							0, //casas
						)}
						
						{this.cardComparativo(
							'custoLitroVenda',
							'Custo por Litro Vendido (R$)',
							custoMedioLitroVenda,
							listaCustoLitroVenda.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorCustoLitroVenda,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}
						
						{this.cardComparativo(
							'receitaFrete',
							'Receitas com Fretes',
							valorTotalReceitaFrete,
							listaReceitaFrete.filter(item => anosSelecionados.includes(parseInt(parseInt(item.competencia) / 100))),
							'valor',
							maiorValorReceitaFrete,
							'R$', //prefixo
							null, //sufixo
							2, //casas
						)}
					</Row>
				</Content>
			</>
        )
    }

	cardComparativo(key, nome, valorTotal, lista, campo, maiorValor, prefixo, sufixo, casas, eventoValor) {

		if (!this.state[key]) {
			return null
		};

		const resumido = this.state.modo == 'resumido';

		return (
			<Grid key={key} cols='4 4 4 4'>
				<ContentCard style={{ borderRadius: 18, overflow: 'hidden' }}>

					<ContentCardHeader>
						<div style={{
							width: '100%',
							textAlign: 'center',
							fontWeight: 600,
							fontSize: 16
						}}>
							{nome}
						</div>
					</ContentCardHeader>

					<ContentCardBody>

						<div style={{
							padding: 8,
							display: 'flex',
							flexDirection: 'column'
						}}>

							{/* TOTAL */}
							<div style={{
								textAlign: 'center',
								fontSize: 24,
								fontWeight: 700,
								color: '#2c2c2c',
								marginBottom: 18
							}}>
								{prefixo} {FormatUtils.formatarValorTelaDecimal(valorTotal, casas)} {sufixo}
							</div>

							{/* LISTA */}
							<div style={{
								height: 300,
								overflowY: 'auto',
								paddingRight: 4
							}}>

								{lista.map(item => {

									let valor = null;
									if (eventoValor) {
										valor = eventoValor(item);
									} else {
										valor = parseFloat(item[campo]);
									}
									const percentual = maiorValor
										? (valor * 100) / maiorValor
										: 0;

									const mesIndex = parseInt(
										String(item.competencia).substring(4, 6)
									) - 1;

									const ano = parseInt(item.competencia / 100);

									const isMaior = valor === maiorValor;

									return (
										<div
											key={item.competencia}
											style={{
												marginBottom: resumido ? 4 : 12,
												padding: resumido ? 8 : 14,
												borderRadius: 12,
												background: isMaior
													? 'rgba(103,101,173,0.08)'
													: '#f7f8fc',
												border: isMaior
													? '1px solid rgba(103,101,173,0.3)'
													: '1px solid #eef0f7',
												transition: 'all 0.2s ease'
											}} >

											{/* HEADER */}
											<div style={{
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
												fontSize: 14,
												fontWeight: 500,
												marginBottom: resumido ? 2 : 8
											}}>
												<span>
													{meses[mesIndex]} de {ano}
												</span>

												<span style={{
													fontWeight: 600
												}}>
													{prefixo} {FormatUtils.formatarValorTelaDecimal(valor, casas)} {sufixo}
												</span>
											</div>

											{/* PROGRESS */}
											<div style={{
												height: 8,
												background: '#e6e8f5',
												borderRadius: 8,
												overflow: 'hidden'
											}}>
												<div style={{
													height: '100%',
													width: `${percentual}%`,
													background: isMaior
														? 'linear-gradient(90deg, #ff853d, #e85802)'
														: 'linear-gradient(90deg, #8289fa, #4e56d4)',
													transition: 'width 0.4s ease'
												}} />
											</div>

											{/* PERCENTUAL TEXTO */}
											{!resumido &&
											<div style={{
												marginTop: 6,
												fontSize: 11,
												textAlign: 'right',
												color: '#777'
											}}>
												{isMaior
													? 'Maior mês'
													: `${FormatUtils.formatarValorTelaDecimal(percentual, 2)}% do maior mês`
												}
											</div>}

										</div>
									);
								})}

							</div>

						</div>

					</ContentCardBody>
				</ContentCard>
			</Grid>
		);
	}

	setModalCustoFolha(registro) {
		this.setState({
			...this.state,
			modalCustoFolha: registro
		});
	}

	modalCustoFolha() {

		if (!this.state.modalCustoFolha) {
			return null;
		}

		let ano = parseInt(parseInt(this.state.modalCustoFolha.competencia) / 100);
		let mes = meses[parseInt(String(this.state.modalCustoFolha.competencia).substring(4, 6)) - 1];

        return (
			<div class='modal fade show' id='modal-md' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Custo com Folha - {mes} de {ano}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setModalCustoFolha(null)}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ }}>
							<Row alignCenter>
								<LabelAndInputNumber 
									cols='12 12 12 12'
									label='Valor'
									placeholder='0,00'
									casas={0}
									value={this.state.modalCustoFolha.valor}
									onChange={data => {
										this.setModalCustoFolha({
											...this.state.modalCustoFolha,
											valor: data.target.value
										});
									}} />
							</Row>

							<Row alignCenter>
								<Grid cols='12 12 12 12' style={{ padding: 16 }}>
									<Button
										text={!this.state.modalCustoFolha.id ? 'Adicionar' : 'Alterar'}
										type={'success'}
										icon={'fa fa-plus'}
										event={() => {
											this.props.salvarCustoFolha({
												...this.state.modalCustoFolha
											});
											this.setModalCustoFolha(null);
										}} />
								</Grid>

								{this.state.modalCustoFolha.id &&
								<Grid cols='12 12 12 12' style={{ padding: 16 }}>
									<Button
										text={'Excluir'}
										type={'danger'}
										icon={'fa fa-plus'}
										event={() => {
											this.props.excluirCustoFolha({
												...this.state.modalCustoFolha
											});
											this.setModalCustoFolha(null);
										}} />
								</Grid>}
							</Row>
						</div>
						<div class='modal-footer justify-content-between' style={{ height: 2, padding: 0, margin: 0 }}>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboardCusto.aguardando,
	listaAnos: state.dashboardCusto.listaAnos,
	listaMeses: state.dashboardCusto.listaMeses,
	listaCustoFolha: state.dashboardCusto.listaCustoFolha,
	listaCustoFrota: state.dashboardCusto.listaCustoFrota,
	listaCustoVendas: state.dashboardCusto.listaCustoVendas,
	listaCustoInvestimentos: state.dashboardCusto.listaCustoInvestimentos,
	listaCustoOutrasDespesas: state.dashboardCusto.listaCustoOutrasDespesas,
	listaCustoAbastecida: state.dashboardCusto.listaCustoAbastecida,
	listaKmRodado: state.dashboardCusto.listaKmRodado,
	listaVenda: state.dashboardCusto.listaVenda,
	listaReceitaFrete: state.dashboardCusto.listaReceitaFrete,
	listaUnidade: state.dashboardCusto.listaUnidade
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getListaCustoFolha, getListaCustoFrota, getListaCustoVendas, getListaCustoInvestimentos, getListaCustoOutrasDespesas,
	getListaCustoAbastecida, getListaKmRodado, 
	salvarCustoFolha, excluirCustoFolha, getListaVenda, getListaReceitaFrete,
	getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DashboardCusto)
